// extracted by mini-css-extract-plugin
module.exports = {"text-column":"TruncatedTextColumn_text-column__2GRI6","has-on-hover":"TruncatedTextColumn_has-on-hover__31ZZT","truncated-note":"TruncatedTextColumn_truncated-note__1GCtz"};